var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95699 12.6798L0.24729 7.83245C-0.072732 7.51505 -0.0835609 6.99122 0.223055 6.6601C0.374741 6.5027 0.58122 6.41416 0.79662 6.41416C1.01202 6.41416 1.2185 6.5027 1.37019 6.6601L4.72272 10.0857V1.24737C4.72272 0.788174 5.0844 0.415921 5.53056 0.415921C5.97672 0.415921 6.3384 0.788174 6.3384 1.24737V10.0857L9.66669 6.6601C9.98721 6.3776 10.465 6.39659 10.7634 6.7037C11.0618 7.01081 11.0802 7.50256 10.8057 7.83245L6.09605 12.6798C5.78096 13.0022 5.27208 13.0022 4.95699 12.6798Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56976 15.5845H1.49136C1.04521 15.5845 0.683524 15.2122 0.683524 14.753C0.683524 14.2938 1.04521 13.9216 1.49136 13.9216H9.56976C10.0159 13.9216 10.3776 14.2938 10.3776 14.753C10.3776 15.2122 10.0159 15.5845 9.56976 15.5845Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportArrow);
export default __webpack_public_path__ + "static/media/importArrow.94c5e47fd778cbdaf7a0486f171fae73.svg";
export { ForwardRef as ReactComponent };